import { styled } from '@mui/system';
import { Box, Button } from '@mui/material';

export const ButtonBox = styled(Box)(() => ({
  position: 'fixed',
  bottom: 0,
  left: 0,
  right: 0,
  width: '100%',
  zIndex: '1000'
}));

export const FixedButton = styled(Button)(() => ({
  height: '72px',
  color: 'white',
  borderRadius: '0'
}));
